import list from './list/routes';
import detail from './detail/routes';

export default [list, detail];
